module.exports = __webpack_public_path__ + "7d70fbd0c4a92286976637fef91af406.fbx";